/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_SeatsInputs */



/**
* | output |
* | --- |
* | "Contracted seats" |
*
* @param {Partner_Add_Customer_Contract_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_seats = /** @type {((inputs?: Partner_Add_Customer_Contract_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertraglich vereinbarte Plätze")
	return /** @type {LocalizedString} */ ("Contracted seats")
});